import { render, staticRenderFns } from "./EditServiceSideBarTabsPricing.vue?vue&type=template&id=d9c86830&scoped=true&"
import script from "./EditServiceSideBarTabsPricing.vue?vue&type=script&lang=js&"
export * from "./EditServiceSideBarTabsPricing.vue?vue&type=script&lang=js&"
import style0 from "./EditServiceSideBarTabsPricing.vue?vue&type=style&index=0&id=d9c86830&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c86830",
  null
  
)

export default component.exports